"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const trace = false;
let all;
let all_index;
const fields = ['code'];
function build() {
    if (all == null) {
        trace && console.time('M49 db');
        all_index = {};
        all = require('un-m49');
        for (let i = 0, l = all.length; i < l; ++i) {
            const isoData = all[i];
            for (let i = 0; i < fields.length; ++i) {
                const field = isoData[fields[i]];
                if (field) {
                    const value = field.toLowerCase();
                    if (trace) {
                        const previous_entry = all_index[value];
                        if (previous_entry && (isoData !== previous_entry)) {
                            trace && console.error(`M49 ${isoData} conflicts with ${previous_entry}`);
                        }
                    }
                    all_index[value] = isoData;
                }
            }
        }
        trace && console.timeEnd('M49 db');
    }
}
function getList() {
    build();
    return all;
}
exports.getList = getList;
function find(data) {
    build();
    const dataLC = data.toLowerCase();
    const isoData = all_index[dataLC];
    return isoData;
}
exports.find = find;
//# sourceMappingURL=m49-impl.js.map